import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import FormSection from "../../../../../common/components/functional/formSection/FormSection";
import { AssignmentRow } from "../AssignmentRow";

type Props = {
  contractName: string;
};

const CustomerContract = ({ contractName }: Props) => {
  const { t } = useTranslation();

  return (
    <FormSection title={t("talentProfile:customerContract")}>
      <AssignmentRow
        label={t("talentProfile:contract")}
        field={<Typography>{contractName}</Typography>}
      />
    </FormSection>
  );
};

export default CustomerContract;
